import Features from '@Features/feature-flags';

export const bannerHeightConstant = 36;

export const severities = {
  error: 'error',
  warning: 'warning',
  info: 'info',
  success: 'success',
};

export const BANNER_MESSAGES = {
  title:
    (Features as any).bannerTitle || 'US PERSONS ONLY US Technical Data / Information permitted',
  subTitle:
    (Features as any).bannerSubTitle ||
    'US PERSONS ONLY US Do not transfer/export without proper export classification and approval.',
};
